module.exports = __webpack_public_path__ + "static/img/btn_bg.3bc230d5.png";